import React from "react";
import { Slide } from "@material-ui/core";

const SlideUp = React.forwardRef((props, ref) => {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default SlideUp;
